import { getInnerApiProxyData } from './proxy'
import adapterRequest from '@remote/api/adapter'
import { request } from '@remote/api/request'
import { IErrorRes } from '@remote/type'
import { getOtherScrapes } from '@remote/api/adapter/shell-mqtt'
/**
 * 获取刮削列表
 */
export const getNFOList: API_NFO.APISet['getNFOList'] = (params: API_NFO.GetNFOListRequest) => {
  return getInnerApiProxyData({
    proxyUrl: 'device/v1/nfos',
    proxyMethod: 'GET',
    proxyParams: params,
  }) as Promise<API_NFO.GetNFOListResponse>
}

/**
 * 增加新的刮削目录
 */
export const createNFODirs: API_NFO.APISet['createNFODirs'] = (params) => {
  return getInnerApiProxyData({
    proxyUrl: 'device/v1/nfo/dirs/add',
    proxyMethod: 'POST',
    proxyData: params,
  }) as Promise<API_NFO.NFOBaseResponse>
}

/**
 * 移除已有的刮削目录
 */
export const removeNFODirs: API_NFO.APISet['removeNFODirs'] = (params) => {
  return getInnerApiProxyData({
    proxyUrl: 'device/v1/nfo/dirs/remove',
    proxyMethod: 'POST',
    proxyData: params,
  }) as Promise<API_NFO.NFOBaseResponse>
}

/**
 * 移除已有的刮削目录
 */
export const getNFODirs: API_NFO.APISet['getNFODirs'] = (params) => {
  return getInnerApiProxyData({
    proxyUrl: 'device/v1/nfo/dirs',
    proxyMethod: 'GET',
    proxyParams: params,
  }) as Promise<API_NFO.GetNFODirsResponse>
}

/**
 * 设置刮削目录
 */
export const setNFODirs: API_NFO.APISet['setNFODirs'] = (params) => {
  return getInnerApiProxyData({
    proxyUrl: 'device/v1/nfo/dirs/set',
    proxyMethod: 'POST',
    proxyData: params,
  }) as Promise<API_NFO.NFOBaseResponse>
}

/**
 * 创建刮削任务
 */
export const createScrapeTask: API_NFO.APISet['createScrapeTask'] = async (action, space) => {
  console.log('createScrapeTask_hezi')
  const [err, result]: [unknown, API_TASK.DriveCreateTaskResponse] = await adapterRequest('/drive/v1/task', {
    space,
    type: 'user#nfo',
    file_size: '0',
    name: '创建刮削任务',
    file_name: '创建刮削任务',
    params: {
      target: space,
      action,
    },
  }, {
    method: 'POST',
  })
  if (err) {
    throw err
  } else if (result.task) {
    return result.task
  } else {
    throw new Error('Create scrape task failed.')
  }
}

export const getRunningScrapeTaskList: API_NFO.APISet['getRunningScrapeTaskList'] = async (space) => {
  const [err, result]: [unknown, API_TASK.DriveListTasksResponse] = (await adapterRequest('/drive/v1/tasks', {
    space,
    limit: 1,
    filters: JSON.stringify({
      phase: { in: 'PHASE_TYPE_PENDING,PHASE_TYPE_RUNNING' },
      type: { in: 'user#nfo' },
    }),
  }, {
    method: 'GET',
  }))
  if (err) {
    throw err
  }
  return result.tasks ?? []
  // if (result?.tasks) {
  //   return result.tasks
  // } else {
  //   throw new Error('result.tasks is empty.')
  // }
}

/**
 * 获取刮削任务状态
 */
export const getScrapeTaskStatus: API_NFO.APISet['getScrapeTaskStatus'] = async (space, taskID) => {
  if (taskID) {
    const [err, result]: [unknown, API_TASK.DriveTask] = await adapterRequest(`/drive/v1/tasks/${taskID}`, {}, { method: 'GET' })
    if (err) {
      throw err
    } else {
      return result
    }
  } else {
    const [err, result]: [unknown, API_TASK.DriveListTasksResponse] = (await adapterRequest('/drive/v1/tasks', {
      space,
      limit: 1,
      filters: JSON.stringify({
        phase: { in: 'PHASE_TYPE_RUNNING,PHASE_TYPE_ERROR,PHASE_TYPE_COMPLETE' },
        type: { in: 'user#nfo' },
      }),
    }, {
      method: 'GET',
    }))
    if (result?.tasks?.[0]) {
      return result.tasks[0]
    } else {
      throw new Error('result.tasks is empty.')
    }
  }
}

export const deleteNFO: API_NFO.APISet['deleteNFO'] = (params) => {
  return adapterRequest('/device/v1/nfos/delete', params, {
    method: 'POST',
  })
  // return getInnerApiProxyData({
  //   proxyUrl: 'device/v1/nfo/delete',
  //   proxyMethod: 'POST',
  //   proxyData: params,
  // }) as Promise<API_NFO.NFOBaseResponse>
}

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=91712280
export const submitFeedback: API_NFO.APISet['submitFeedback'] = (params) => {
  const host = 'https://mdb.v.geilijiasu.com'
  const url = 'resource-parse/v1/feedback'
  return request(`${host}/${url}`, params, {
    method: 'POST',
  })  as Promise<[IErrorRes, API_NFO.NFOBaseResponse]>
}

export const uploadFeedbackImage: API_NFO.APISet['uploadFeedbackImage'] = (params) => {
  return getInnerApiProxyData({
    proxyUrl: 'device/v1/nfo/upload_image',
    proxyMethod: 'POST',
    proxyData: params,
  })
}

export function getDramas (id: number, pageSize = 100) {
  return adapterRequest('/device/v1/nfos/dramas', {
    id: id,
    page_size: pageSize,
  }, { apiEnv: 'heziProduction' })
}

export function getDramasByInfo (params:{name:string; year:string}, pageSize = 100) {
  return adapterRequest('/device/v1/nfos/dramas', {
    ... params,
    class: 'tv',
    page_size: pageSize,
  }, { apiEnv: 'heziProduction' })
}

interface TSearchResourceParams {
  name:string
  limit:number
}

export interface ISearchResourceRetItem {
  'name': string
  'trans_name': string
  'other_name': string
  'class': string
  'origin_place': string
  'brief':string
  'year': string
  'actors': {name: string}[]
  'directors': {name: string}[]
  'post_url': [string, string]
  'season': string
  'episode': string
  'title': string
  'xmdb_id': string
}
interface ISearchResourceRet {
  ret:number
  data: ISearchResourceRetItem[]
}

export const searchResource= (params:TSearchResourceParams):Promise<[IErrorRes, ISearchResourceRet]> => {
  const url = '/device/v1/resource/search'
  return adapterRequest(url, params, {
    method: 'POST',
    apiEnv: 'heziProduction',
  })
}

interface IUpdateResourceParams {
  file_id: string
  scrape_id: number
  scrape_data: ISearchResourceRetItem
}

export const updateResource = (params:IUpdateResourceParams):Promise<[IErrorRes, {ret: number}]> => {
  const url = '/device/v1/resource/update'
  return adapterRequest(url, params, {
    method: 'POST',
    apiEnv: 'heziProduction',
  })
}

export const updateAllResource = (params:IUpdateResourceParams):Promise<[IErrorRes, {ret: number}]> => {
  const url = '/device/v1/resource/update_all'
  return adapterRequest(url, params, {
    method: 'POST',
    apiEnv: 'heziProduction',
  })
}

export const getScrapeVersion = ():Promise<[IErrorRes, {ret: number; data: number}]> => {
  const url = '/api/v1/user/scrape_version'
  return adapterRequest(url, {}, {
    method: 'GET',
    apiEnv: 'heziProduction',
  })
}

export const getOtherNFOList = (params: {page_size: number; last_page_token:string}) => {
  return getOtherScrapes(params)
}

export const getNFORecommend = (params:Partial<API_NFO.IGetNFORecommendParams>) => {
  const url = '/device/v1/nfos/media_recommends'
  return adapterRequest(url, params, {
    method: 'GET',
    apiEnv: 'heziProduction',
  }).then(res => res.data)
}

export const getNFOInfo = (fileId: string) => {
  const url = '/device/v1/nfos/info'
  return adapterRequest(url, {file_id: fileId}, {
    method: 'GET',
    apiEnv: 'heziProduction',
  }).then(res => res.data)
}

export const API: API_NFO.APISet = {
  getNFODirs,
  createNFODirs,
  createScrapeTask,
  getNFOList,
  getRunningScrapeTaskList,
  getScrapeTaskStatus,
  removeNFODirs,
  setNFODirs,
  deleteNFO,
  submitFeedback,
  uploadFeedbackImage,
  getScrapeVersion,
  getOtherNFOList,
  getNFORecommend,
}
